import type {
    AddProductAndRemoveOldestMutationVariables,
    AddProductToWishlistMutationVariables,
    ChangeProductSizeInWishlistMutationVariables,
    ChangeQuantityInWishlistMutationVariables,
    RemoveProductFromWishlistMutationVariables,
} from "@graphql/generated/types";

import { useCommerceToolsClient } from "@lib/commerce/adapters/commercetools/useCommerceToolsClient";
import { updateMutation } from "@store/helpers";
import { useStore } from "@store/store";

export const useAddProductToWishlist = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.addProductToWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<AddProductToWishlistMutationVariables>(executeWithVariables, setData);
};

export const useAddProductAndRemoveOldestFromWishlist = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.addProductAndRemoveOldest;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<AddProductAndRemoveOldestMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useRemoveProductFromWishlist = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.removeProductFromWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<RemoveProductFromWishlistMutationVariables>(
        executeWithVariables,
        setData
    );
};

export const useUpdateProductQtyInWishlist = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.changeQuantityInWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<ChangeQuantityInWishlistMutationVariables>(executeWithVariables, setData);
};

export const useUpdateProductSizeInWishlist = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.changeProductSizeInWishlist;
    const setData = useStore((state) => state.setWishlist);
    return updateMutation<ChangeProductSizeInWishlistMutationVariables>(
        executeWithVariables,
        setData
    );
};
